import FloatingMemberSituationSelect from '@components/FloatingMemberSituationSelect'
import ExternalIncomeTable from '@components/tables/ExternalIncomeTable'
import OrdersTable from '@components/tables/OrderTable'
import OrganismsTable from '@components/tables/OrganismTable'
import VisitsTable from '@components/tables/VisitsTable'
import { TabContext, TabPanel } from '@mui/lab'
import { Tab, Tabs } from '@mui/material'
import React, { useState } from 'react'
import logo from '../../../../src/assets/img/logos/ariane-fse.png'
import ResipLayout from '../../../../src/layouts/ResipLayout'
import AccountingLayout from './Accounting/AccountingLayout'
import { PatientsContainer } from './PatientsContainer'
import { useIntl } from 'react-intl'

export default function Worklists() {
  const [value, setValue] = useState(0)
  const intl = useIntl()

  function a11yProps(index: number) {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    }
  }

  const handleChange = (_: React.SyntheticEvent, newValue: number) => {
    setValue(newValue)
  }

  return (
    <>
      <TabContext value={value.toString()}>
        <div>
          <Tabs
            value={value}
            onChange={handleChange}
            aria-label="basic tabs example"
            className="bg-white"
          >
            <Tab
              label={intl.formatMessage({ id: 'dossiers' })}
              {...a11yProps(0)}
            />
            <Tab
              label={intl.formatMessage({
                id: 'sejourPatient',
              })}
              {...a11yProps(1)}
            />
            <Tab
              label={intl.formatMessage({ id: 'patients' })}
              {...a11yProps(2)}
            />
            <Tab
              label={intl.formatMessage({
                id: 'externalResources',
              })}
              {...a11yProps(3)}
            />
            <Tab
              label={intl.formatMessage({ id: 'followUpManagement' })}
              {...a11yProps(4)}
            />
            <Tab
              label={intl.formatMessage({
                id: 'mutualFunds',
              })}
              {...a11yProps(5)}
            />
            <Tab
              label={intl.formatMessage({
                id: 'accounting',
              })}
              {...a11yProps(6)}
            />
          </Tabs>
          <TabPanel value="0">
            <OrdersTable />
          </TabPanel>
          <TabPanel value="1">
            <VisitsTable />
          </TabPanel>
          <TabPanel value="2">
            <PatientsContainer />
          </TabPanel>
          <TabPanel value="3">
            <ExternalIncomeTable />
          </TabPanel>
          <TabPanel value="4">
            <ResipLayout />
          </TabPanel>
          <TabPanel value="5">
            <OrganismsTable />
          </TabPanel>
          <TabPanel value="6">
            <AccountingLayout />
          </TabPanel>
        </div>
      </TabContext>
      <div className="absolute rounded-full top-6 right-6 -translate-y-1/2">
        <img src={logo} alt="logo" className="w-[176px]" />
      </div>
    </>
  )
}
